module.exports = __webpack_public_path__ + "static/img/color.36db070e.jpg";